import { TimelineItemView } from '../view/TimelineItemView';
import { templateTimelineItem } from '../view/template';
import {
  BaseWebComponentController,
  IListenerConfig,
  WebComponentEvent,
} from '../../../framework/BaseWebComponentController';
import { TimelineItemWebComponent } from '..';
import {
  KillChainPhases,
  SeverityColors,
  SeverityScores,
  TimelineItemWebComponentSchema,
  OPEN_OTHER_ALERTS_EVENT_NAME,
} from '../types';
import { Alert } from '../../timelineGroup/types';

export class TimelineItemController extends BaseWebComponentController {
  public component: TimelineItemWebComponent;
  public view: TimelineItemView;
  public viewConstructor: typeof TimelineItemView;

  private classIcon = new Map<KillChainPhases, string>([
    [KillChainPhases.INITIAL_ACCESS, 'ds-icon-Initial-access_2c'],
    [KillChainPhases.EXECUTION, 'ds-icon-Execution_2c'],
    [KillChainPhases.PERSISTENCE, 'ds-icon-Persistence_4c'],
    [KillChainPhases.PRIVILEGE_ESALATION, 'ds-icon-Privilege-escalation_2c'],
    [KillChainPhases.DEFENCE_EVASION, 'ds-icon-Defense-evasion_4c'],
    [KillChainPhases.CREDENTIAL_ACCESS, 'ds-icon-Credential-access_2c'],
    [KillChainPhases.DISCOVERY, 'ds-icon-Discovery_2c'],
    [KillChainPhases.LATERAL_MOVEMENT, 'ds-icon-Lateral-movement_2c'],
    [KillChainPhases.COLLECTION, 'ds-icon-Collection_2c'],
    [KillChainPhases.COMMAND_AND_CONTROL, 'ds-icon-Command-and-control_2c'],
    [KillChainPhases.EXFILTRATION, 'ds-icon-Exfiltration_2c'],
    [KillChainPhases.IMPACT, 'ds-icon-Impact_2c'],
  ]);

  private severityColor = new Map<SeverityScores, SeverityColors>([
    [SeverityScores.SEVERITY_LOW, SeverityColors.SEVERITY_LOW],
    [SeverityScores.SEVERITY_MEDIUM, SeverityColors.SEVERITY_MEDIUM],
    [SeverityScores.SEVERITY_HIGH, SeverityColors.SEVERITY_HIGH],
  ]);

  constructor(component: TimelineItemWebComponent) {
    super(component);
    this.initialSetup({
      viewConstructor: TimelineItemView,
      viewTemplate: templateTimelineItem,
    });
  }

  computeEventListeners(): IListenerConfig[] {
    return [
      {
        element: this.view.dom.$identicalTactic,
        event: 'click',
        callback: this.openOtherAlertsEvent.bind(this),
      },
    ];
  }

  openOtherAlertsEvent() {
    this.component.dispatchEvent(
      new CustomEvent(OPEN_OTHER_ALERTS_EVENT_NAME, {
        bubbles: true,
        composed: true,
        detail: { info: this.component.killChainPhases },
      })
    );
  }

  async getDataForView(): Promise<TimelineItemWebComponentSchema> {
    return {
      classIcon: this.classIcon.get(this.component.killChainPhases),
      alertTitle: this.component.alertTitle,
      killChainPhases: this.component.killChainPhases,
      severity: this.component.severity,
      severityColor: this.severityColor.get(this.component.severity),
      alertDescription: this.component.alertDescription,
      sensor: this.component.sensor,
      identicalTactic: this.component.identicalTactic,
      numberOfEndpoints: this.component.numberOfEndpoints,
      numberOfServers: this.component.numberOfServers,
      numberOfInternalEmails: this.component.numberOfInternalEmails,
      numberOfIps: this.component.numberOfIps,
      numberOfIdentities: this.component.numberOfIdentities,
    };
  }
}
